module.exports = __webpack_public_path__ + "3a7afda0e4ac1f370ac85ae5d6f55130.svg";